// theme.js
// Color scheme based on design plan

const theme = {
  colors: {
    primary: {
      background: '#121212',
      lighter: '#1E1E2D',
    },
    accent: {
      teal: '#00B2A9',
      coral: '#FF6B6B',
    },
    text: {
      primary: '#FFFFFF',
      secondary: '#E0E0E0',
    },
    gradient: {
      start: '#121212',
      end: '#1E1E2D',
    }
  },
  fonts: {
    heading: "'Montserrat', sans-serif",
    body: "'Open Sans', sans-serif",
    mono: "'Roboto Mono', monospace",
  },
  fontSizes: {
    h1: '3.5rem',
    h2: '2.5rem',
    h3: '1.75rem',
    body: '1rem',
    small: '0.875rem',
  },
  spacing: {
    xs: '0.25rem',
    sm: '0.5rem',
    md: '1rem',
    lg: '2rem',
    xl: '4rem',
  },
  breakpoints: {
    mobile: '320px',
    tablet: '768px',
    desktop: '1024px',
  }
};

export default theme;
